const al = {
 "studio": "Resource Studio",
 "studioSub": "Trouver → Prévisualiser → Adapter → Assigner. Jeu de test : {n} ressources.",
 "search": "Rechercher des ressources",
 "all": "Tous",
 "language": "Langue",
 "level": "Niveau",
 "type": "Type",
 "eligibility": "Disponible dans",
 "why": "Pourquoi c'est adapté",
 "reg": {"label": "Registre", "unspecified": "Non précisé", "v": {"formal": "Formel", "informal": "Informel", "mixed": "Mixte", "neutral_na": "Neutre / sans objet"}, "edit": "Modifier", "choose": "Choisir le registre", "notePh": "Note courte (facultative)", "notePhMixed": "Qui utilise quelle forme ? (obligatoire si mixte)", "noteNeeded": "Un registre mixte demande une note courte.", "saved": "Registre enregistré. Texte de l'activité inchangé."},
 "teacherOnly": "Enseignant uniquement",
 "answerKey": "Corrigé",
 "rubric": "Grille",
 "notes": "Notes pour l'enseignant",
 "preview": "Aperçu élève",
 "adapt": "Adapter",
 "assign": "Assigner à la classe",
 "assigned": "Assigné à votre classe.",
 "adapted": "Votre copie adaptée est enregistrée. L'original n'a pas changé.",
 "titleLabel": "Titre",
 "instructionsLabel": "Consignes pour l'élève",
 "save": "Enregistrer la copie",
 "cancel": "Annuler",
 "noResults": "Aucune ressource ne correspond à ces filtres.",
 "previewNote": "Contenu de test — ne fait pas partie de la future bibliothèque",
 "lab": "Discovery Lab",
 "labSub": "Découvrir → essayer → comprendre → utiliser. Quelques petites activités à explorer.",
 "secTry": "Essaie ceci",
 "secPattern": "Explore une structure",
 "secSolve": "Résous quelque chose",
 "secRead": "Lis et découvre",
 "check": "Vérifier",
 "score": "{c} sur {t} correctes",
 "tryAgain": "Réessayer",
 "done": "Terminé",
 "know": "Je sais",
 "again": "Encore",
 "flip": "Touchez pour retourner",
 "keep": "Garder pour ma pratique personnelle",
 "kept": "Enregistré dans votre banque de vocabulaire.",
 "cantKeep": "La langue de ce jeu ne fait pas partie de vos langues d'apprentissage ; impossible de l'enregistrer.",
 "practiceDone": "Pratique enregistrée pour votre classe.",
 "results": "Résultats de la classe",
 "completed": "Terminé",
 "attempted": "Commencé",
 "notAttempted": "Pas commencé",
 "classResources": "Ressources de la classe",
 "open": "Ouvrir",
 "minutes": "{n} min",
 "failed": "Un problème est survenu. Veuillez réessayer.",
 "close": "Fermer",
 "cardOf": "{i} / {n}",
 "pickClass": "Choisir une classe",
 "mine": "Mes adaptations",
 "explored": "Exploré",
 "fam": {
  "grammar": "Grammaire",
  "worksheet": "Fiche",
  "memory": "Cartes mémoire",
  "game": "Énigme",
  "form": "Formulaire",
  "document": "Document authentique",
  "speaking": "Oral",
  "reading": "Lecture et culture",
  "assessment": "Évaluation",
  "data": "Défi de données"
 },
 "elig": {
  "public": "Public",
  "pro": "Pro",
  "education": "Éducation"
 }
};
al.p = {
 "sev": {"low": "Faible", "medium": "Moyenne", "high": "Élevée"},
 "area": {"language_accuracy": "Exactitude de la langue", "naturalness": "Naturel", "cefr_fit": "Niveau CECRL", "answer_key": "Corrigé", "instructions": "Consignes", "pedagogy": "Pédagogie", "culture_stereotypes": "Culture et stéréotypes", "duplication": "Doublons", "formatting_script": "Mise en forme et écriture", "provenance": "Provenance", "objective_alignment": "Alignement sur l'objectif", "teacher_learner_match": "Cohérence enseignant/élève"},
 "edited": "modifié",
 "precheck": "Pré-relecture IA",
 "precheckRun": "Lancer la pré-relecture IA",
 "precheckRerun": "Relancer",
 "precheckNone": "Pas encore de pré-relecture.",
 "precheckStale": "version précédente",
 "corrections": "{n} corrections proposées (non appliquées)",
 "precheckAdvisory": "Indicatif uniquement : ne valide ni ne modifie jamais la ressource.",
 "pv": {"pass": "IA : OK", "revise": "IA : à revoir", "attention": "IA : attention humaine requise"},
 "badJson": "JSON invalide.",
 "contentSaved": "Contenu enregistré ; l'ancien reste dans l'historique.",
 "editContent": "Modifier le contenu",
 "editTrail": "Chaque modification est journalisée avec l'ancien contenu.",
 "history": "Versions",
 "startRevision": "Démarrer une révision",
 "revisionStarted": "Brouillon v{v} créé. La version validée reste en ligne.",
 "histAssign": "{n} assignations gardent leur version figée.",
 "confirmElig": "J'ai vérifié la disponibilité : {e}",
 "confirmEligFirst": "Confirme d'abord la disponibilité.",
 "objective": "Objectif",
 "provenance": "Provenance",
 "wave": "Filtrer la vague",
 "booklet": "Livret",
 "summary": "PDF résumé",
 "showMore": "Afficher {n} de plus",
 "showLess": "Afficher moins",
 "checklistIncomplete": "Coche d'abord chaque point de la grille.",
 "across": "Horizontalement",
 "down": "Verticalement",
 "clueListNote": "Écris chaque réponse à côté de son numéro. Le nombre entre parenthèses indique les lettres.",
 "again": "S'entraîner encore",
 "exportVersion": "Version",
 "print": "Imprimer",
 "export": "Exporter",
 "theme": "Thème",
 "grammar": "Grammaire",
 "vocab": "Vocabulaire",
 "function": "Fonction communicative",
 "duration": "Minutes",
 "teacherInstr": "Consignes pour l'IA (facultatif)",
 "canonical": "Brouillon canonique GetFluentLoop (part en relecture)",
 "draftSaved": "Brouillon enregistré. Il reste privé jusqu'à ce que tu le marques prêt.",
 "draftNote": "Brouillon IA : vérifie langue, niveau et réponses avant d'enregistrer.",
 "fromFile": "Créé à partir de",
 "saveDraft": "Enregistrer le brouillon",
 "uploaded": "Fichier ajouté à tes fichiers.",
 "aiNote": "Les brouillons IA commencent toujours en privé. Rien n'est publié ni assigné automatiquement.",
 "uploadNote": "Importe un PDF, Word, texte, CSV ou Excel. L'original ne change pas ; l'activité est un brouillon privé séparé.",
 "uploadedAs": "enregistré comme ressource.",
 "useAsResource": "Utiliser comme ressource ✓",
 "orCreate": "ou crée une activité à partir de celui-ci :",
 "generating": "Génération…",
 "generate": "Générer un brouillon",
 "createFromFile": "Créer une activité à partir de ceci",
 "suggestedBy": "Proposé par un enseignant",
 "checklist": "Grille qualité",
 "checklistNote": "Relecture humaine. Coche chaque point ; les réserves doivent être levées avant.",
 "reviewNote": "Note de relecture / validation (interne)",
 "reviewSub": "File éditoriale du contenu canonique GetFluentLoop. Les notes restent internes.",
 "reviewEmpty": "Rien ici.",
 "packName": "Nom du pack",
 "packCreated": "Pack créé.",
 "packsSub": "Les packs regroupent ressources, missions et fichiers. Les packs personnels restent privés sauf partage par un admin d'école.",
 "createPack": "Créer un pack",
 "packsEmpty": "Aucun pack pour l'instant.",
 "school": "École",
 "private": "Privé",
 "packSaved": "Enregistré comme pack.",
 "subSub": "Compose un cours de remplacement uniquement avec des ressources validées, sans IA.",
 "themeOptional": "Thème (facultatif)",
 "buildLesson": "Composer le cours",
 "lessonTotal": "Cours : {n} min (demandé {r})",
 "mission": "mission",
 "missing": "Pas encore de ressource validée",
 "subNote": "Imprime chaque partie depuis Resource Studio. Les corrigés restent réservés aux enseignants.",
 "savePack": "Enregistrer comme pack",
 "linked": "Ajouté à la mission.",
 "useInMission": "Utiliser dans une mission",
 "startMission": "Commencer un brouillon de mission",
 "orExisting": "ou ajoute-le à une de tes missions :",
 "noMissions": "Aucune mission enregistrée dans cette langue.",
 "attach": "Ajouter",
 "addedToPack": "Ajouté au pack.",
 "choosePack": "Choisir un pack",
 "addToPack": "Ajouter au pack",
 "readyDone": "Prêt à assigner.",
 "markReady": "Marquer prêt",
 "unshared": "Plus partagé.",
 "shared": "Partagé avec ton école.",
 "unshare": "Arrêter le partage",
 "share": "Partager avec l'école",
 "suggest": "Proposer à la bibliothèque GetFluentLoop",
 "draftPrivate": "Brouillon privé : toi seul le vois. Marque-le prêt pour l'assigner.",
 "suggestNote": "Une copie séparée est créée pour les éditeurs GetFluentLoop. Ta version ne change pas.",
 "rights": "Tes droits de partage",
 "suggestNotePh": "Une information pour les éditeurs (facultatif)",
 "suggested": "Envoyé en relecture GetFluentLoop.",
 "send": "Envoyer",
 "denied": "Resource Studio est réservé aux enseignants vérifiés.",
 "draftNoAssign": "Marque-le prêt avant de l'assigner.",
 "schoolShared": "Partagé dans mon école",
 "missionResources": "Ressources de cette mission",
 "attachResources": "Joindre des ressources (même langue)",
 "noCompatible": "Aucune ressource prête dans cette langue.",
 "previewCombined": "Aperçu avec ressources",
 "pickMissionFor": "Choisis une mission à associer à {id} ({lang}), puis joins-la à l'étape d'assignation.",
 "ver": {
  "learner": "Fiche élève",
  "teacher": "Version enseignant",
  "answer_key": "Corrigé",
  "teacher_guide": "Guide enseignant"
 },
 "grp": {
  "individual": "Individuel",
  "pairs": "Binômes",
  "groups": "Groupes",
  "whole_class": "Classe entière"
 },
 "mode": {
  "ai": "Brouillon IA",
  "upload": "À partir d'un fichier"
 },
 "out": {
  "worksheet": "Fiche d'exercices",
  "grammar_discovery": "Découverte grammaticale",
  "flashcards": "Cartes mémoire",
  "crossword": "Mots croisés / puzzle",
  "interactive_form": "Formulaire interactif",
  "reading": "Lecture",
  "speaking_cards": "Cartes d'oral",
  "exit_ticket": "Ticket de sortie",
  "data_challenge": "Défi données"
 },
 "st": {
  "draft": "Brouillon",
  "reviewed": "Relu",
  "approved": "Validé",
  "retired": "Retiré",
  "superseded": "Remplacé",
  "teacher_ready": "Prêt"
 },
 "cv": {
  "pass": "OK",
  "concern": "Réserve",
  "na": "N/A"
 },
 "do": {
  "reviewed": "Marquer relu",
  "approved": "Valider",
  "draft": "Renvoyer en brouillon",
  "retired": "Retirer"
 },
 "pp": {
  "warmups": "Échauffements 10 min",
  "speaking": "Semaine de l'oral",
  "revision": "Révisions d'examen",
  "reading": "Semaine de lecture",
  "grammar": "Découverte grammaticale",
  "substitute": "Remplaçant",
  "other": "Autre"
 },
 "slot": {
  "starter": "Démarrage",
  "main": "Activité principale",
  "speaking": "Oral",
  "resource": "Fiche / ressource",
  "exit": "Ticket de sortie"
 },
 "rt": {
  "own_work": "Création personnelle",
  "cc_by": "CC BY",
  "cc0": "CC0",
  "public_domain": "Domaine public",
  "licensed_for_reuse": "Licence de réutilisation"
 },
 "tab": {
  "library": "Bibliothèque",
  "create": "Créer",
  "packs": "Packs",
  "substitute": "Pack remplaçant",
  "review": "Relecture"
 },
 "ck": {
  "language_correct": "Langue correcte",
  "cefr_fit": "Niveau CECRL adapté",
  "objective_clear": "Objectif clair",
  "meaningful_language_use": "Exige un vrai usage de la langue",
  "learner_instructions": "Consignes élève claires",
  "teacher_instructions": "Consignes enseignant claires",
  "cultural_credibility": "Crédible culturellement",
  "stereotype_risk": "Pas de stéréotypes",
  "age_context": "Adapté à l'âge et au contexte",
  "copyright_provenance": "Droits / provenance OK",
  "privacy": "Aucune donnée personnelle",
  "cards_accurate": "Cartes exactes",
  "roles_balanced": "Rôles équilibrés",
  "data_plausible": "Données plausibles",
  "answer_key_correct": "Corrigé exact",
  "puzzle_solvable": "Puzzle faisable",
  "text_level": "Texte au bon niveau",
  "authentic_format": "Format authentique",
  "realistic_form": "Formulaire réaliste"
 }
};
export default al;
